import React from 'react';
import '@/assets/sass/style.scss';
import Swagger from '@/components/Swagger';
import environmentData from '@/config/environment.json';
import { EnvironmentType } from '@/types/environmentType';
import { SpecUrlsProvider } from '@/context/SpecUrlsContext';

const environment = environmentData as EnvironmentType;

const Main = () => {
  return (
    <>
      <SpecUrlsProvider>
        <Swagger environment={environment} />
      </SpecUrlsProvider>
    </>
  );
};

export default Main;
